import {isNumber} from './validate';
export function addUnit(value) {
    value = String(value);
    return isNumber(value) ? ''.concat(value, 'px') : value;
}
